import { render, staticRenderFns } from "./layout-diy.vue?vue&type=template&id=8456e0ce&"
import script from "./layout-diy.vue?vue&type=script&lang=js&"
export * from "./layout-diy.vue?vue&type=script&lang=js&"
import style0 from "./layout-diy.vue?vue&type=style&index=0&id=8456e0ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports